import { isDevMode } from "@/config/envvars";

/**
 * A raw response dumped into a message (`HTTP 403 {"error":…}`) rather than a
 * sentence written for people.
 */
const RAW_RESPONSE = /[{[]\s*["}\]]|\bHTTP \d{3}\b/;

/**
 * The error text a person may see. Raw JSON responses only ever show on
 * dev/local; elsewhere a message carrying one is dropped, and the caller falls
 * back to its own generic copy.
 */
export function visibleErrorText(raw: string | null | undefined): string | null {
  const text = raw?.trim();
  if (!text) return null;
  if (isDevMode) return text;
  return RAW_RESPONSE.test(text) ? null : text;
}
